<script>
	import Cookie from 'js-cookie'
	import Login from './login.svelte'
	import {USER} from './store.js'
	import Cliente from './cliente/cliente.svelte'
	import Ventas from './ventas/ventas.svelte'
	import Pagos from './pagos/pagos.svelte'
	import Usuarios from './usuarios/usuarios.svelte'
	import Tipocob from './tipos-cob/tipos-cob.svelte'
	import CRM from './crm/crm.svelte'
	import Cartera from './cartera/cartera.svelte'
	import Tesoreria from './tesoreria/tesoreria.svelte'
	import Semanas from './tablas/semanas.svelte'
	import Pundia from './tablas/pundia.svelte'
	import CAM from './tablas/cam.svelte'
	import Reservas from './reservas/menu-reservas.svelte'
	

	let usr = Cookie.get('gsc-user') || '{ "username":"" , "fullname":"" , "aclist":"" }'
	USER.set(JSON.parse(usr))

	const menu_options = [
		{ title: 'Clientes', component: Cliente , icon: 'bi-person'},
		{ title: 'Ventas', component: Ventas , icon: 'bi-file-person'},
		{ title: 'Pagos', component: Pagos , icon:'bi-cash'},
		{ title: 'Tesoreria', component: Tesoreria , icon:'bi-bank'},
		{ title: 'Usuarios',  component: Usuarios, icon:'bi-people-fill'  },
		{ title: 'Tipos Cobranza',  component: Tipocob, icon:'bi-bicycle'  },
		{ title: 'Reservas',  component: Reservas, icon:'bi-sun'  },
		{ title: '',  component: '', icon:''  },
		{ title: 'Salir del sistema',   component: Login  , icon:'bi-box-arrow-up-right'},
	];

	let menu = ( $USER.username ==="") ? menu_options[2] : menu_options[0]

	let show=false

	function toggle(){
		show = !show
	}

	function setComponent(itm){
		menu = itm
	}

	function set_page(ev){
		let idx = ev.detail.page || 0
		menu = menu_options[idx]
	}

	let ver_crm = false
	function toggle_crm(){
		ver_crm = !ver_crm
	}
	let ver_cartera = false
	function toggle_cartera(){
		ver_cartera = !ver_cartera
	}
	let ver_tabla_semanas = false
	function toggle_tabla_semanas(){
		ver_tabla_semanas = !ver_tabla_semanas
	}
	let ver_tabla_pundia = false
	function toggle_tabla_pundia(){
		ver_tabla_pundia = !ver_tabla_pundia
	}
	let ver_tabla_cam = false
	function toggle_tabla_cam(){
		ver_tabla_cam = !ver_tabla_cam
	}
</script>

{#if $USER.username !== ''}
	<div class="bg-success mb-2">
		<span class="btn btn-sm mb-2 text-white" data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample" on:hover={()=>show=true}>
			<i class="bi-grid-fill"></i>&nbsp;&nbsp;<b>Rincon Club</b>
		</span>
		
		<span class="badge rounded-pill bg-light text-success float-end me-2 mt-3 px-1 ">{$USER.username}</span>
		<div class="bg-light border-bottom d-flex justify-content-end">
				<span class="btn btn-link btn-sm" on:click={toggle_tabla_cam}><b>CAM</b></span>
				<span class="btn btn-link btn-sm" on:click={toggle_tabla_semanas}>Semanas</span>
				<span class="btn btn-link btn-sm" on:click={toggle_tabla_pundia}>PunDia</span>
				<span class="btn btn-link btn-sm" on:click={toggle_cartera}>Cartera</span>
				<span class="btn btn-link btn-sm" on:click={toggle_crm}>CRM</span>
		</div>
		<div class="offcanvas offcanvas-start {show?'show':''}" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
		  <div class="offcanvas-header">
		    <h5 class="offcanvas-title" id="offcanvasExampleLabel">&nbsp;</h5>
		    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
		  </div>
		  <div class="offcanvas-body">
		  	{#each menu_options as item, index}
		  		{#if item.title !== ''}
	  			<div on:click={()=>setComponent(item)}  data-bs-dismiss="offcanvas" class="my-2 is-hover p-2">
		  			<i class="{item.icon} me-2"></i>{item.title}
		  		</div>
		  		{:else}
		  			<hr>
		  		{/if}
		  	{/each}

		  </div>

		</div>
	</div>

	<div class="container-fluid">
		<svelte:component this={menu.component} on:close={set_page}/>
	</div>
{:else}
	<Login on:close={set_page} />
{/if}


{#if ver_crm}
	<CRM on:close={toggle_crm}/>
{/if}

{#if ver_cartera}
	<Cartera on:close={toggle_cartera}/>
{/if}

{#if ver_tabla_semanas}
	<Semanas on:close={toggle_tabla_semanas}/>
{/if}

{#if ver_tabla_pundia}
	<Pundia on:close={toggle_tabla_pundia}/>
{/if}

{#if ver_tabla_cam}
	<CAM on:close={toggle_tabla_cam}/>
{/if}
